import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchBlogEntryList({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get(`/blogEntry?${formatParams(params)}`)
      .then((blogEntries) => {
        commit('setData', blogEntries);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteBlogEntry(_, id) {
    return axios.delete(`/blogEntry/${id}`);
  },
};
